<template>
	<div v-if="item" class="fs18 prelative pt pr10 clearn dflex" :class="{gray: item.can_enroll ? false : true}" @click="checkCanBm(item)">
		<span v-if="trainType == 5" class="fs18 stt ofhidden">{{ item.trainProject ? item.trainProject.name : '' }}</span>
		<span v-else class="fs18 stt ofhidden">{{ item.name }}</span>
		<div class="sfr fr">
			<span v-if="trainType == 5" class="dt tc9 fs14 dblock">
				<div class="dinline-block mr15">
					<span>期数：</span>
					<span class="tc3">{{ item.name }}</span>
				</div>
				<div class="dinline-block mr15">
					<span>作业类别：</span>
					<span class="tc3">{{ item.trainProject ? item.trainProject.train_type : '' }}</span>
				</div>
				<div class="dinline-block">
					<span>准操项目：</span>
					<span class="tc3">{{ item.trainProject ? item.trainProject.train_project : '' }}</span>
				</div>
			</span>

			<span v-if="trainType != 5 && item.enroll_start_dt != '1970-01-01' && item.enroll_end_dt != '1970-01-01'" class="dt tc9 fs14 dblock">
				报名时间：{{ item.enroll_start_dt }} ~ {{ item.enroll_end_dt }}
			</span>

			<div v-if="item.can_enroll" class="btns dnone">
				<a @click="goSign(item)" href="javascript:void(0)" class="zbtn zbtn-bblue fs14 mr5">我要报名</a>
				<template v-if="trainType == 3 || trainType == 5">
					<a @click="goSearch(item)" href="javascript:void(0)" class="zbtn zbtn-bblue fs14 mr5">报名查询</a>
				</template>
				<template v-if="trainType != 4">
					<a @click="controlCode(1)" @mouseleave="controlCode(0)" href="javascript:void(0)"
						class="zbtn zbtn-bblue fs14 prelative pn mr5">手机报名
						<div ref="dimg" class="dimg dnone pabsolute bgw pt10">
							<div class="qrcode-div" :id="'qrcode-item-div' + item.id"></div>
							<div class="fs12 tc9 mt5">扫一扫，手机报名</div>
						</div>
					</a>
				</template>
				<router-link v-if="trainType == 5" :to="{
					path: '/train/project/detail',
					query: {
						id: (item.trainProject ? item.trainProject.id : 0),
						period: item.id
					}
				}" class="zbtn zbtn-bblue fs14 mr5">详细情况</router-link>
				<router-link v-else :to="`/train/project/detail?id=${item.id}&project_id=${item.trainProject.id}`"
					class="zbtn zbtn-bblue fs14 mr5">详细情况
				</router-link>
			</div>
		</div>

	</div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
	name: 'ItemNew',

	props: {
		item: {
			type: Object
		},
		trainType: {
			default: 3
		},
		sign: {
			type: Function
		}
	},

	data() {
		return {
			'is_flag': 0
		}
	},

	mounted() {
		this.$nextTick(() => {
			if (this.trainType == 4) {
				return
			}
			this.creatQrCode('qrcode-item-div' + this.item.id, this.item.id, this.item.name, this.item.trainProject.id)
		})
	},

	methods: {
		creatQrCode(qrCodeUrl, id, name, project_id) {
			var docd = document.getElementById(qrCodeUrl)
			var that = this
			if (docd) {
				docd.innerHTML = ''
				let work_option = this.item.trainProject.work_option
				//默认3技能
				let txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign?id=' + id +
					'&name=' + name + '&work_option=' + work_option + '&project_id=' + project_id
				// console.log(txt)
				if (this.trainType == 5) { //特种工
					id = this.item.trainProject.id
					const period = this.item.id
					txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign-up-tz?id=' + id +
						'&period=' + period + '&project_id=' + project_id
				} else if (this.trainType == 1) { //社会培训
					txt = 'http://' + document.domain + that.$router.options.base + 'mobile/train/project/sign-up?id=' + id +
						'&project_name=' + this.item.trainProject.name + '&project_id=' + project_id
				}
				//console.log(txt)
				var qrcode = new QRCode(docd, {
					text: txt, // 需要转换为二维码的内容
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			}
		},
		controlCode(is_flag) {
			this.is_flag = is_flag
			this.$refs.dimg.style.display = this.is_flag ? 'block' : 'none'
		},
		goSign(item) { //我要报名
			// 1 社会培训 2委托培训 3技能 4中职教师培训 5特种作业操作工培训与考证
			if (this.trainType == 5) { // 特种工
				this.$router.push({
					path: '/train/project/sign-up-tz',
					query: {
						id: item.trainProject.id,
						period: item.id,
						flow: 1
					}
				})
			} else if (this.trainType == 3) { // 技能
				localStorage.setItem('ITEMJN', item.trainProject.work_option)
				this.$router.push(`/train/project/sign?id=${item.id}&project_id=${item.trainProject.id}&name=${item.name}&flow=1`)
			} else { // 其它 点击弹出
				this.$emit('sign', item)
			}
		},
		goSearch(item) { //报名查询
			if (this.trainType == 5) {
				this.$router.push({
					path: '/train/project/sign-up-tz',
					query: {
						id: item.trainProject.id, // 项目id
						period: item.id, // 班级id
						flow: 4
					}
				})
			} else if (this.trainType == 3) {
				this.$router.push(`/train/project/sign?id=${item.id}&project_id=${item.trainProject.id}&name=${item.name}&flow=2`)
			}
		},
		checkCanBm(item){
			if(!item.can_enroll)
				alert('报名已结束')
		}
	}
}
</script>

<style scoped>
.gray .stt{
	color: #999;
}
.gray.pt::before{
	background: #999;
}
.pt {
	margin-bottom: 5px;
	padding: 0 10px 0 25px;
	height: 42px;
	line-height: 42px;
}

.pt::before {
	content: '';
	position: absolute;
	top: 20px;
	left: 10px;
	width: 4px;
	height: 4px;
	background: #213f68;
}

.pt:hover {
	background: #f6f6f6;
}

.pt:hover .stt {
	font-weight: bold;
	color: #1492ff;
}

.pt:hover .dt {
	display: none;
}

.pt:hover .btns {
	display: block;
}

.stt {
	display: inline-block;
	padding-right: 80px;
	width: 480px;
	height: 42px;
	white-space: nowrap;
	text-overflow: ellipsis;
	flex: auto;
}

.sfr {
	white-space: nowrap;
	text-overflow: ellipsis;
}

.sfr .dinline-block {
	white-space: nowrap;
}

.zbtn-bblue {
	padding: 8px 15px;
	line-height: 1;
	border: 1px solid #1492ff;
	border-radius: 10px;
	color: #1492ff;
}

.zbtn-bblue:hover {
	color: #fff;
}

.pn .dimg {
	z-index: 2;
	left: 100%;
	top: 50%;
	transform: translateY(-50%);
	padding: 15px 15px 10px;
	box-shadow: 0 0 5px #ccc;
}

.pn:hover .dimg {
	/*display: block;*/
}

.qrcode-div {
	width: 100px;
	height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/train/project/ItemNew.vue